
const dataSlider = [
    {
        id: 1,
        title: "Sansevieria Trifasciata",
        subTitle: "Lengua de suegra, Laurentii",
        description: "Vulputate, ante leo fermentum nulla, sit amet ornare lorem eros a massa, leo fermentum.",
        category: "Plantas de interior",
        luz: 1,
        agua: 1,
        frio: 3,
        price: 18.04,
        entero: 18,
        decimales: ".04",
        image: "card1.jpg"
    },
    {
        id: 2,
        title: "Buganvilla Rosa",
        subTitle: "Bougainvillea Escarlet, Flor de papel",
        description: "Vulputate, ante leo fermentum nulla, sit amet ornare lorem eros a massa, leo fermentum.",
        category: "Plantas con flor",
        luz: 2,
        agua: 2,
        frio: 2,
        price: 29.99,
        newPrice: 15.00,
        entero: 15,
        decimales: ".00",
        image: "card2.jpg"
    },
    {
        id: 3,
        title: "Pachira Aquatica",
        subTitle: "Arbol de la riqueza, Castaña de agua",
        description: "Vulputate, ante leo fermentum nulla, sit amet ornare lorem eros a massa, leo fermentum.",
        category: "Plantas de interior",
        luz: 1,
        agua: 1,
        frio: 1,
        price: 23.74,
        entero: 23,
        decimales: ".74",
        image: "card3.jpg"
    },
    {
        id: 4,
        title: "Ave del Paraíso",
        subTitle: "Ave del paraíso, platanero",
        description: "Vulputate, ante leo fermentum nulla, sit amet ornare lorem eros a massa, leo fermentum.",
        category: "Plantas de exterior",
        luz: 3,
        agua: 2,
        frio: 0,
        price: 46.99,
        newPrice: 40.65,
        entero: 40,
        decimales: ".65",
        image: "card4.jpg"
    },
    {
        id: 5,
        title: "Margarita  Blanca",
        subTitle: "Matacabras, Estrella polar",
        description: "Vulputate, ante leo fermentum nulla, sit amet ornare lorem eros a massa, leo fermentum.",
        category: "Plantas con flor",
        luz: 3,
        agua: 2,
        frio: 1,
        entero: 18,
        decimales: ".99",
        image: "card5.jpg"
    },
    {
        id: 6,
        title: "Petunia Roja",
        subTitle: "Flor de los aztecas, calibrocha",
        description: "Vulputate, ante leo fermentum nulla, sit amet ornare lorem eros a massa, leo fermentum.",
        category: "Plantas con flor",
        luz: 3,
        agua: 2,
        frio: 0,
        entero: 16,
        decimales: ".99",
        image: "card6.jpg"
    },
];

export default dataSlider;